import ClubItemBase from "./club_item_base";

const {ccclass, property} = cc._decorator;

@ccclass
export default class ClubHallItem extends ClubItemBase {

    

    
}
